import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, filter, first, map, timeout } from 'rxjs/operators';
import { MenuService } from 'app/shared/layouts/admin/services/menu.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DefaultRouteGuard implements CanActivate {
  private readonly menuService = inject(MenuService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  canActivate(): Observable<boolean> {
    return this.menuService.menuItems.pipe(
      filter(items => items.length > 0),
      first(),
      timeout(5000),
      map(items => {
        const rota = (items[0]?.['route'] as string) ?? '/login';
        this.router.navigate([rota]);
        return false;
      }),
      catchError(() => {
        void this.authService.logout();
        return of(false);
      }),
    );
  }
}
